import { ConfigProvider } from "antd";
import type { ReactNode } from "react";

/**
 * FinEase brand accent — aligned with Tailwind `brandPrimary` (#66A0CD).
 * Scopes Ant Design Switch / Checkbox / other primary-colored controls to match the admin theme.
 */
export const FINEASE_BRAND_PRIMARY = "#66A0CD";

type FinEaseAntdScopeProps = {
  children: ReactNode;
};

export function FinEaseAntdScope({ children }: FinEaseAntdScopeProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: FINEASE_BRAND_PRIMARY,
        },
        components: {
          Switch: {
            colorPrimary: FINEASE_BRAND_PRIMARY,
          },
          Checkbox: {
            colorPrimary: FINEASE_BRAND_PRIMARY,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
